import { useReducerContext } from 'hooks/useReducerContext'

import JobsBox from './JobsBox'

const JobsBoxContainer = () => {
  const [contextData] = useReducerContext()

  if (contextData.jobsBox.from === 0) return null

  return <JobsBox fromDate={new Date(contextData.jobsBox.from)} />
}

export default JobsBoxContainer
